import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/faqs";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream py-20 md:py-28" aria-labelledby="faq-title" data-id="element-70" data-mp="1bmd6p6zvac52">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-[1fr_1.6fr]" data-id="element-71" data-mp="1gkerbwcxyjin">
        <h2 id="faq-title" className="font-display text-4xl uppercase leading-none text-ink md:text-6xl" data-id="element-72" data-mp="24a91g65vltz7">
          Questions fréquentes
        </h2>
        <ul className="border-t border-walnut/15" data-id="element-73" data-mp="1ujwjmlpg4ewr">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.question} className="border-b border-walnut/15" data-id="element-74" data-mp="1zgmzp9193ai6" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-walnut" data-id="element-75" data-mp="2n70qkw83n3b6">
                  <span className="font-serif text-xl text-ink" data-id="element-76" data-mp="10rm2paod5tf0">{f.question}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-walnut transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-77" data-mp="1emoiqqmxcz5j" />
                </button>
                <AnimatePresence initial={false} data-id="element-78" data-mp="1jjex99j2zmou">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-79" data-mp="1xiwpxzzhzk3h">
                      <p className="max-w-2xl pb-6 leading-relaxed text-stone" data-id="element-80" data-mp="1y9391sbhbpyq">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}